import type { I18n } from "@lingui/core"
import { msg } from "@lingui/core/macro"

/**
 * Frontend-local sentiment vocabulary.
 *
 * The backend analysis schema owns the canonical enum; this is the SHARED
 * display layer so the value set + their localised labels aren't duplicated
 * between `MeetingCard/helpers` and `MeetingSummary/parts/SentimentLabel`. Any
 * value the analyser hands us that isn't in this set falls through to the raw
 * string at the call site.
 */
export const SENTIMENT_KEYS = ["productive", "creative", "tense", "mixed", "neutral"] as const

export type TSentiment = (typeof SENTIMENT_KEYS)[number]

/** Localised display label for a sentiment key. Unknown keys return undefined. */
export function sentimentLabelFor(i18n: I18n, key: string): string | undefined {
  switch (key) {
    case "productive":
      return i18n._(msg`Productive`)
    case "creative":
      return i18n._(msg`Creative`)
    case "tense":
      return i18n._(msg`High friction`)
    case "mixed":
      return i18n._(msg`Mixed`)
    case "neutral":
      return i18n._(msg`Neutral`)
    default:
      return undefined
  }
}
